@let isCustomDeleted = isDisabled() && getCustomValueState('id');

<mat-expansion-panel
  class="cta-expansion-panel"
  [class.analytics-mode-panel]="analyticsMode()"
  [class.view-mode]="isViewMode()"
  [disabled]="isCustomDeleted || analyticsMode()"
  [expanded]="(isPanelExpanded() && !isCustomDeleted) || analyticsMode()"
  [hideToggle]="analyticsMode()"
  (expandedChange)="onPanelExpandedChange($event)"
>
  <mat-expansion-panel-header class="deliverable-flow-expansion-panel-header">
    <mat-panel-title>
      @if (formArray.length > 0) {
        <div class="flex flex-1 gap-3 items-center" [class.justify-between]="!analyticsMode()">
          <app-editable-title
            fontClasses="font-bold"
            [class.text-sm]="!analyticsMode()"
            [icon]="form().invalid ? 'icons/circle-x.svg' : 'icons/circle-check.svg'"
            [iconColor]="form().invalid ? 'var(--shikenso-error-bright)' : 'var(--shikenso-pink-base)'"
            [iconSize]="16"
            [subtitle]="config.subtitleTranslationKey | translate"
            [control]="name"
            [isViewMode]="isViewMode()"
            [disabled]="isCustomDeleted"
            [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
            [hideManualDeliverableStatusTooltip]="
              form().value['type'] === EDeliverableType.textTracking ||
              form().value['type'] === EDeliverableType.audioTracking
            "
            [infoTooltip]="
              'pages.campaignForm.ctaDialog.ctaDetails.deliverables.descriptions.' + config.type | translate
            "
            [creatorBriefingMode]="creatorBriefingMode()"
            [showRequiredBadge]="showRequiredBadge()"
          />

          @if (!isViewMode()) {
            <div class="flex items-center gap-7">
              <app-deliverable-advanced-button
                [platformFeature]="platformFeature()"
                [deliverableType]="config.type"
                [isOpen]="showAdvancedSettings()"
                (toggled)="onToggleAdvancedSettings()"
              />

              <div class="flex items-center">
                @if (isCustomMode() && !form().value.exclusiveTo) {
                  <app-custom-remove-button
                    [checked]="!getCustomValueState('id')"
                    (checkboxStateChanged)="onDeleteCheckboxChange('id', $event)"
                    #deleteParentButton
                  />
                } @else {
                  <button
                    mat-icon-button
                    type="button"
                    class="mat-secondary-transparent-button-color"
                    (click)="onDeleteClick(form().value.exclusiveTo)"
                  >
                    <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
    </mat-panel-title>

    @if (isCustomDeleted) {
      <svg
        class="absolute top-1/2 -translate-y-1/2 right-1 opacity-[24%] w-6 h-6 mt-[1px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
      </svg>
    }
  </mat-expansion-panel-header>

  <div [formGroup]="form()">
    <ng-content select="[chatbotIntervals]"></ng-content>

    @if (!isTrackingDeliverable()) {
      <div class="flex items-center justify-between gap-6 mb-5 mt-2 pl-3">
        <div class="flex items-center gap-6">
          <span class="text-sm">
            {{
              'pages.campaignForm.ctaDialog.ctaDetails.deliverables.textDeliverable.fulfillmentRequirements' | translate
            }}
          </span>
          <mat-radio-group formControlName="matchMode" class="flex items-center gap-4">
            <mat-radio-button [value]="ETextDeliverableMatchMode.and">
              {{
                'pages.campaignForm.ctaDialog.ctaDetails.deliverables.textDeliverable.allKeywordsRequired' | translate
              }}
            </mat-radio-button>
            <mat-radio-button [value]="ETextDeliverableMatchMode.or">
              {{
                'pages.campaignForm.ctaDialog.ctaDetails.deliverables.textDeliverable.anyKeywordRequired' | translate
              }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        @if (isCustomMode() && !isViewMode() && getCustomValueState('matchMode') && !form().value.exclusiveTo) {
          <button
            mat-icon-button
            type="button"
            class="mat-secondary-transparent-button-color"
            [disabled]="isDisabled()"
            (click)="onRevertToGlobalClick('matchMode')"
          >
            <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
          </button>
        }
      </div>
    }

    <div [formArrayName]="config.arrayFieldName" class="flex flex-col gap-3 flex-1">
      @for (control of formArray.controls; track control; let i = $index) {
        @if (
          !control.value.exclusiveTo || isViewMode() || (isCustomMode() && control.value.exclusiveTo === creatorId())
        ) {
          <div
            class="flex gap-2 transition-colors duration-300 rounded-lg -mx-3 px-3 -my-1 py-1"
            [formGroupName]="i"
            [class.bg-shikenso-pink-base-12]="isNewlyAddedElement(control.value.id ?? '')"
            [attr.data-element-id]="control.value.id ?? ''"
          >
            <div class="flex flex-col flex-1 min-w-0">
              <mat-form-field
                class="flex-1 no-padding-prefix"
                matTooltipPosition="above"
                [class.custom-value-border]="
                  isCustomMode() &&
                  !isViewMode() &&
                  (getCustomValueState(config.contentFieldName, i) || control.value.exclusiveTo)
                "
                [matTooltip]="isViewMode() ? control.value[config.contentFieldName] : null"
              >
                <mat-label>{{ config.placeholderTranslationKey | translate }} {{ i + 1 }}</mat-label>
                <input
                  matInput
                  [formControlName]="config.contentFieldName"
                  (focus)="onInputFocus(i)"
                  (blur)="onInputBlur(i)"
                />

                @if (
                  (config.type === EDeliverableType.hashTag || config.type === EDeliverableType.mention) &&
                  (isFieldFocused(i) || control.controls[config.contentFieldName].value)
                ) {
                  <div
                    matPrefix
                    class="flex items-center justify-center pt-4 absolute top-[-18px]"
                    [class.left-[-8px]]="config.type === EDeliverableType.hashTag"
                    [class.left-[-14px]]="config.type === EDeliverableType.mention"
                  >
                    <span class="text-sm font-bold text-shikenso-purple-base" [class.opacity-[38%]]="isViewMode()">
                      {{ config.type === EDeliverableType.hashTag ? '#' : '@' }}
                    </span>
                  </div>
                }

                @if (
                  isCustomMode() &&
                  !isViewMode() &&
                  getCustomValueState(config.contentFieldName, i) &&
                  !control.value.exclusiveTo
                ) {
                  <span matSuffix>
                    <button
                      mat-icon-button
                      type="button"
                      class="mat-secondary-transparent-button-color"
                      [disabled]="isCustomDeleted || control.disabled"
                      (click)="onRevertToGlobalClick(config.contentFieldName, i)"
                    >
                      <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
                    </button>
                  </span>
                }
                <mat-error [control]="control.get(config.contentFieldName)" />
              </mat-form-field>

              @if (!isViewMode() && hasMultipleKeywords(control)) {
                <span class="text-[10px] h-8 pr-4 pl-6 leading-[14px] pt-1.5 text-shikenso-warning-base">
                  {{
                    'pages.campaignForm.ctaDialog.ctaDetails.deliverables.textDeliverable.multipleKeywordsHint'
                      | translate
                  }}
                </span>
              }
            </div>

            @if (
              control.value.status &&
              isViewMode() &&
              showStatusBadge() &&
              manualDeliverableStatusConfig()?.statusVisible
            ) {
              @let countFn = analyticsKeywordCounts();
              @let resolvedCount = countFn ? countFn(control.value.text) : control.value.analyticsCurrentCount;
              @let isAnalyticsCountVisible = resolvedCount !== null && resolvedCount !== undefined;

              <div class="ml-1" [class.pt-4]="!isAnalyticsCountVisible" [class.pt-3]="isAnalyticsCountVisible">
                <app-analytics-status-badge
                  [status]="control.value.status"
                  [currentCount]="resolvedCount"
                  [loading]="analyticsBadgeLoading()"
                  [neutralCompletedStatus]="isTrackingDeliverable()"
                  [hideStatusBadge]="isTrackingDeliverable()"
                  [jumpActionDisabled]="disableAnalyticsKeywordJumpAction(control.value.text)"
                  [showJumpActionLoader]="showAnalyticsKeywordJumpLoader(control.value.text)"
                  [showJumpAction]="showAnalyticsKeywordJumpAction(control.value.text)"
                  [showPillLoader]="isAnalyticsCountVisible"
                  (jumpAction)="onAnalyticsKeywordJump(control.value.text)"
                />
              </div>
            }

            @if (!isViewMode()) {
              @if (isCustomMode() && !control.value.exclusiveTo) {
                <div
                  class="mt-3"
                  matTooltipPosition="left"
                  [matTooltip]="
                    (isCustomDeleted || (deleteChildButton.isChecked && isChildDeleteDisabled())) && !control.disabled
                      ? ('pages.campaignForm.ctaDialog.ctaDetails.deliverables.lastSubItemCannotBeDisabled' | translate)
                      : ''
                  "
                >
                  <app-custom-remove-button
                    [checked]="!getCustomValueState('id', i)"
                    [disabled]="isCustomDeleted || (deleteChildButton.isChecked && isChildDeleteDisabled())"
                    (checkboxStateChanged)="onDeleteCheckboxChange('id', $event, i)"
                    #deleteChildButton
                  />
                </div>
              } @else {
                <div
                  class="mt-3"
                  matTooltipPosition="left"
                  [matTooltip]="
                    isCustomDeleted || isChildDeleteDisabled()
                      ? ((isGlobalTracking()
                          ? 'pages.campaignForm.sections.keywordTracking.lastSubItemCannotBeDeleted'
                          : 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.lastSubItemCannotBeDeleted'
                        ) | translate)
                      : lastActiveChildElementDetails().has(control.value.id ?? '')
                        ? (config.lastActiveCannotBeDeletedTranslationKey | translate) +
                          lastActiveChildElementDetails().get(control.value.id ?? '')?.creatorNames
                        : ''
                  "
                >
                  <button
                    mat-icon-button
                    type="button"
                    class="mat-secondary-transparent-button-color"
                    [disabled]="
                      isCustomDeleted ||
                      isChildDeleteDisabled() ||
                      lastActiveChildElementDetails().has(control.value.id ?? '')
                    "
                    (click)="removeArrayElement(i)"
                  >
                    <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                  </button>
                </div>
              }
            }
          </div>
        }
      }
    </div>
  </div>

  @if (formArray.length > 0 && !isViewMode()) {
    <div class="flex justify-start mt-3">
      <button
        mat-flat-button
        type="button"
        color="secondary-transparent"
        class="w-fit mat-slim-button"
        (click)="addArrayElement()"
      >
        <div class="flex items-center gap-1">
          <app-icon src="/icons/plus.svg" alt="add" class="w-5 h-5" />
          <span>
            {{ config.addButtonTranslationKey | translate }}
          </span>
        </div>
      </button>
    </div>
  }

  @if (showAdvancedSettings() && !isViewMode()) {
    <div class="pl-3 mt-4">
      <app-deliverable-advanced-settings-section
        [form]="form()"
        [platformFeature]="platformFeature()"
        [deliverableType]="config.type"
        [isCustomMode]="isCustomMode()"
        [creatorId]="creatorId()"
      />
    </div>
  }
</mat-expansion-panel>
